<script lang="ts">
  import { createEventDispatcher } from 'svelte';

  import { Button } from '@shared/ui/buttons/button';
  import { PhoneField } from '@shared/ui/fields/phone-field';
  import { TextField } from '@shared/ui/fields/text-field';

  import type { PurchaseForm } from '../config';
  import { getPurchaseFormData } from '../model';

  export let formData: PurchaseForm;
  export let formAction: string | undefined = undefined;
  export let isOpen: boolean = false;

  let input: HTMLInputElement;

  const dispatcher = createEventDispatcher();

  const handleSuccessSubmit = () => {
    dispatcher('successSubmit');
  };

  const handleCancel = () => {
    dispatcher('cancel');
  };

  const { form, errors, submitting, enhance } = getPurchaseFormData(formData, handleSuccessSubmit);

  $: getErrors = (name: string): string => {
    const err = ($errors as { [key: string]: string[] })[name];
    if (!err || !err.length) return '';

    return err[0];
  };

  $: if (isOpen) {
    setTimeout(() => {
      input?.focus();
    }, 300);
  }
</script>

<form method="POST" use:enhance action="{formAction}">
  <div class="flex w-full flex-col">
    <TextField
      label="Full Name*"
      bind:value="{$form.name}"
      bind:input
      state="{$errors.name && 'error'}"
      helperText="{getErrors('name')}"
      placeholder="John Galt"
      inputmode="text"
      name="name"
    />

    <TextField
      label="Email*"
      bind:value="{$form.email}"
      state="{$errors.email && 'error'}"
      helperText="{getErrors('email')}"
      placeholder="johngalt@gmail.com"
      inputmode="email"
      name="email"
    />

    <PhoneField
      bind:value="{$form.phone}"
      state="{$errors.phone && 'error'}"
      helperText="{getErrors('phone')}"
      label="Phone"
      placeholder="Phone"
      mask="phone"
    />
  </div>

  <Button type="submit" loading="{$submitting}" class="mb-5">Send Request</Button>

  <button type="button" class="group mx-auto flex pb-[0.5px] text-base font-medium" on:click="{handleCancel}">
    <div
      class="underline-group-hover underline-static underline-top-1 before:bg-default-900/50 after:bg-default-600/50 dark:before:bg-default-200/50"
    >
      Cancel
    </div>
  </button>
</form>
